(() => {
  if (customElements.get('greens-subscription-offer')) return;

  class GreensSubscriptionOffer extends HTMLElement {
    connectedCallback() {
      this.form = this.closest('form[action*="/cart/add"]');
      this.planInput = this.querySelector('[data-greens-selling-plan]');
      this.legal = this.querySelector('[data-greens-legal]');
      this.oneTimeRadio = this.querySelector('input[value="one_time"]');
      this.subscriptionRadio = this.querySelector('input[value="subscription"]');
      this.onChange = this.onChange.bind(this);
      this.onSubmit = this.onSubmit.bind(this);
      this.onFormData = this.onFormData.bind(this);
      if (!this.form || !this.planInput) return;

      this.addEventListener('change', this.onChange);
      this.form.addEventListener('submit', this.onSubmit, { capture: true });
      this.form.addEventListener('formdata', this.onFormData);
      const previouslySelected = this.form.dataset.greensPurchaseMode;
      const initialMode = previouslySelected || (this.dataset.defaultSubscription === 'true' ? 'subscription' : 'one_time');
      this.setMode(initialMode);
    }

    disconnectedCallback() {
      this.removeEventListener('change', this.onChange);
      if (this.form) {
        this.form.removeEventListener('submit', this.onSubmit, { capture: true });
        this.form.removeEventListener('formdata', this.onFormData);
      }
    }

    onChange(event) {
      if (event.target.matches('.greens-offer__radio')) {
        this.setMode(event.target.value);
      }
    }

    setMode(mode) {
      const isSubscriptionAllowed = this.dataset.planAvailable === 'true' && Boolean(this.dataset.planId);
      const selectedMode = mode === 'subscription' && isSubscriptionAllowed ? 'subscription' : 'one_time';
      const useSubscription = selectedMode === 'subscription';
      this.form.dataset.greensPurchaseMode = selectedMode;
      this.planInput.disabled = !useSubscription;
      this.planInput.value = this.dataset.planId || '';
      if (this.subscriptionRadio) this.subscriptionRadio.checked = useSubscription;
      if (this.oneTimeRadio) this.oneTimeRadio.checked = !useSubscription;
      if (this.legal) this.legal.hidden = !useSubscription;
      this.querySelectorAll('[data-greens-option]').forEach((card) => {
        card.classList.toggle('is-selected', card.dataset.greensOption === selectedMode);
      });
    }

    onFormData(event) {
      if (this.oneTimeRadio?.name) event.formData.delete(this.oneTimeRadio.name);
    }

    onSubmit(event) {
      const useSubscription = this.form.dataset.greensPurchaseMode === 'subscription';
      if (!useSubscription) {
        this.planInput.disabled = true;
        return;
      }
      const valid = this.dataset.planAvailable === 'true' && this.dataset.planId;
      if (!valid || this.planInput.disabled || this.planInput.value !== this.dataset.planId) {
        event.preventDefault();
        event.stopImmediatePropagation();
        this.setMode('one_time');
        console.error('Greens: the selling plan is missing or invalid.');
      }
    }
  }

  customElements.define('greens-subscription-offer', GreensSubscriptionOffer);
})();
